import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import moment from 'moment';
import Modal from 'modules/common/components/Modal';
import { Acl } from 'modules/common/components/Acl';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';

import ViewOfficialReceipt from './or-components/ViewOfficialReceipt';
import ViewUpdateOfficialReceipt from './or-components/ViewUpdateOfficialReceipt';
// import ViewORModal from './ViewORModal';
// import AddPaymentModal from './AddPaymentModal';

import * as actions from '../actions';
import * as c from '../constant';

const ViewOfficialReceiptListingModal = ({
  // id,
  permissions,
  paymentListing,
  isLoading,

  getListManualImportBorongan,
  updateORNumber,
  isOrUpdating  ,
}) => {
  const setModal = useContext(ModalContext);
  const [viewOR, setViewOR] = useState({ isActive: false, data: ''})
  const [updateOR, setUpdateOR] = useState({ isActive: false, data: ''})
  const [formData, setFormData] = useState({ or_no: '',})

  const validateForm = useFormValidator(formData, { or_no: 'required' });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleViewOR = paymentId => {
    setViewOR({
      ...viewOR,
      isActive: true,
      data: paymentId,
    })
  };

  const handleUpdateOR = paymentId => {
    setUpdateOR({
      ...updateOR,
      isActive: true,
      data: paymentId,
    })
  };  

  // for submitting updated OR
  
  const handleSubmitUpdatedOR = paymentId => e => {
    e.preventDefault()

    updateORNumber(paymentId, formData, () => {
      getListManualImportBorongan({ is_active: 1 })
      setViewOR({ ...viewOR, isActive: false, data: "" })
      setUpdateOR({ ...updateOR, isActive: false, data: "" })
      setModal({ isOpen: false });
    })
    return true
  }

  return (
    <Modal.Body>
      <>
        {(!_.get(viewOR, "isActive") && !_.get(updateOR, "isActive")) && 
          (
            <div className="">
              <table className="table table-sm table-hover bordered">
                <thead className="table-header">
                  <tr>
                    <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                      OR Number{' '}
                      {isLoading && (
                        <i className="fas fa-spinner fa-spin fa-lg ml-2" />
                      )}
                    </th>
                    <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middler">
                      Date Paid
                    </th>
                    <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                      Amount Paid
                    </th>
                    <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                      Status
                    </th>
                    <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody className="table-details w-100">
                  {_.isEmpty(paymentListing) && (
                    <div className="py-4 d-flex justiy-content-center align-items-center">
                      No Available Receipt.
                    </div>
                  )}
                  {paymentListing?.map(item => {
                    return (
                      <tr className="billing-table-tr" key={_.get(item, 'id')}>
                        <td className="py-3 align-middle">
                          {_.get(item, 'or_no') || '---'}
                        </td>
                        <td className="py-3 align-middle">
                          {moment(`${_.get(item, 'paid_at')}`).format(
                            'MMM DD, YYYY'
                          ) || '---'}
                        </td>
                        <td className="py-3 align-middle">
                          <b>PHP</b>&nbsp;
                          {_.get(item, 'amount') || '0.00'}
                        </td>
                        <td className="py-3 align-middle">
                          <span className='bg-success px-2 rounded text-light'>{_.get(item, 'period')}</span>
                        </td>
                        {/* view or */}
                        <td
                          className={`p-3 align-middle ${Acl(permissions, ['RPTAX BILLINGS ALLOW DELETE',]) === false && Acl(permissions, ['UPDATE RECORD RPTAX']) === false && 'd-none'}`}
                          style={{ width: '124px' }}
                        >
                          {/* View OR */}
                          {Acl(permissions, ['VIEW RPTAX BILLING OFFICIAL RECEIPT']) && (
                            <button
                              type="button"
                              disabled={!_.get(item, 'or_no')}
                              className="btn-blank py-0 pl-0 pr-2 m-0"
                              onClick={() => handleViewOR(_.get(item, 'id'))} 
                            >
                              <i
                                className={`fas icon-view-only ${_.get(item, 'or_no') ? 
                                  "fa-eye cms-bg-color-primary" : "fa-eye-slash bg-dark"}`}
                                style={{ opacity: `${_.get(item, 'or_no') ? "1": ".3"}`}} 
                              />
                            </button>
                          )}
                          {/* udpate OR */}
                          {Acl(permissions, ['VIEW RPTAX BILLING UPDATE OR']) && (
                            <button
                              type="button"
                              className="btn-blank"
                              onClick={() => handleUpdateOR(_.get(item, 'id'))}
                            >
                              <i className="far fa-list-alt icon-payment cms-bg-color-primary" />
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )
        }
        {/*  display VIEW OR */}
        { _.get(viewOR, "isActive") && <ViewOfficialReceipt paymentId={_.get(viewOR, "data")} />}
        {/*  display UPDATE OR */}
        { _.get(updateOR, "isActive") && <ViewUpdateOfficialReceipt formData={formData} setFormData={setFormData} validateForm={validateForm} />}
        
        {/* FOOTER */}
        <div className="d-flex justify-content-center">
          {(_.get(viewOR, "isActive") || _.get(updateOR, "isActive")) && (
            <button
              type="button"
              onClick={() => {
                setViewOR({ ...viewOR, isActive: false, data: "" })
                setUpdateOR({ ...updateOR, isActive: false, data: "" })
              }}
              className="btn btn-primary"
            >
              <span className="font-weight-bold">Go Back</span>
            </button>
          )}
          <button type="button" onClick={closeModal} className="btn btn-dark mx-2">
            <span className="font-weight-bold">Close</span>
          </button>
          {_.get(updateOR, "isActive") && (
            <button
              type="button"
              disabled={!validateForm.response.is_passed}
              className="btn btn-light cms-bg-color-primary"
              onClick={handleSubmitUpdatedOR(_.get(updateOR, "data"))}
              style={{ color: '#fff' }}
            >
              {isOrUpdating ? <i className="fas fa-spinner fa-spin fa-lg" /> : 'Submit'}
            </button>
          )}
        </div>
      </>
    </Modal.Body>
  );
};

ViewOfficialReceiptListingModal.defaultProps = {
  paymentListing: []
};

ViewOfficialReceiptListingModal.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  // id: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  paymentListing: PropTypes.instanceOf(Array),
  updateORNumber: PropTypes.instanceOf(Function).isRequired,  
  isOrUpdating: PropTypes.bool.isRequired,
  getListManualImportBorongan: PropTypes.instanceOf(Function).isRequired,
};  

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  isLoading: api.loading.indexOf(c.VIEW_PAYMENT_LISTING) > -1,
  isOrUpdating: api.loading.indexOf(c.UPDATE_OR_NUMBER) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, { ...actions }),
]);

export default enhance(ViewOfficialReceiptListingModal);
